import { render, staticRenderFns } from "./PhotoInstructions.vue?vue&type=template&id=47352e16&scoped=true"
import script from "./PhotoInstructions.vue?vue&type=script&lang=js"
export * from "./PhotoInstructions.vue?vue&type=script&lang=js"
import style0 from "./PhotoInstructions.vue?vue&type=style&index=0&id=47352e16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47352e16",
  null
  
)

export default component.exports